(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9407],{

/***/ 9803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.828 11H20v2H7.828l5.364 5.364-1.414 1.414L4 12l7.778-7.778 1.414 1.414z"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrow);

/***/ }),

/***/ 94432:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies",
      function () {
        return __webpack_require__(54391);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57508:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/documentation-card.a8fe56b8.png","height":315,"width":383,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAATlBMVEW79NXI+d2z78zC9tnc/eut7sjF+NvE9tnQ+eLM+t/Z/+vC9tnP/OPN++HH+Ny889Pk//Pm/+/B9djI992z89Sh6MO589KQ5L2v8tKW4Lli/d42AAAAFHRSTlPzoZzrT9v4vDTdrczow4p7sFDhZV7pceEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA7SURBVAiZBcEHAoAgDACxY7bg1hb0/x81oUAoY+zU19r6+ckCskEgihxR5KH6bGl6J5m1262j+VLNWX9HxwJXCk01vAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 7272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var reakit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76152);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84193);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var variants = {
    primary: "text-cornflower bg-faded-cornflower",
    secondary: "text-white bg-zodiac",
    default: "text-zodiac bg-white border border-primary-100 hover:text-white hover:bg-zodiac"
};
function Badge(param) {
    var slug = param.slug, title = param.title, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, className = param.className, _as = param.as, as = _as === void 0 ? "link" : _as;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline-block rounded text-xs font-medium leading-[22px] transition-colors duration-200", variants[variant], className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reakit__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, _objectSpread({
            as: as === "link" ? _components_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : "span"
        }, as === "link" && {
            href: slug
        }, {
            className: "block h-full w-full px-2 text-[color:inherit]",
            children: title
        }))
    }));
};


/***/ }),

/***/ 89130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardCTALink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84193);



function CardCTALink(param) {
    var href = param.href, text = param.text, className = param.className;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: href,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("group flex items-center text-sm font-medium text-cornflower", className),
        children: [
            text || "Read post",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                viewBox: "0 0 16 16",
                fill: "currentColor",
                xmlns: "http://www.w3.org/2000/svg",
                className: "ml-2 inline-flex h-4 w-4 transform transition-transform duration-100 group-hover:translate-x-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.4714 3.52876C10.2111 3.26841 9.78898 3.26841 9.52865 3.52876C9.26831 3.78911 9.26831 4.21122 9.52865 4.47157L12.3906 7.3335H2.00004C1.63185 7.3335 1.33337 7.63196 1.33337 8.00016C1.33337 8.36836 1.63185 8.66683 2.00004 8.66683H12.3906L9.52865 11.5288C9.26831 11.7891 9.26831 12.2112 9.52865 12.4716C9.78898 12.7319 10.2111 12.7319 10.4714 12.4716L14.469 8.47402C14.4772 8.46593 14.4851 8.45763 14.4929 8.44913C14.5429 8.39432 14.5821 8.33317 14.6105 8.26843C14.6467 8.18635 14.6667 8.0956 14.6667 8.00016C14.6667 7.90473 14.6467 7.81398 14.6105 7.73189C14.5821 7.66715 14.5429 7.60601 14.4929 7.55119C14.4851 7.54269 14.4772 7.53439 14.469 7.52631L10.4714 3.52876Z",
                    fill: "currentColor"
                })
            })
        ]
    }));
};


/***/ }),

/***/ 11417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CardsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function CardsContainer(param) {
    var children = param.children, className = param.className;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("grid grid-cols-1 gap-x-6 gap-y-10 md:grid-cols-2 md:gap-y-20 lg:grid-cols-3", className),
        children: children
    }));
};


/***/ }),

/***/ 16206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EnterpriseCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84193);
/* harmony import */ var _svg_icons_arrow_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9803);



function EnterpriseCard() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative h-full overflow-hidden rounded-lg bg-deep-sea shadow-image transition-all duration-300 ease-in-out hover:shadow-card-hover",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_link__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            href: "/contact",
            className: "block h-full w-full px-4 pb-9 pt-12 md:px-9 md:pt-16",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative z-10 flex h-full flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                            className: "mb-6 max-w-[380px] text-xl font-bold leading-tight text-white md:text-[38px]",
                            children: [
                                "Lets talk about your",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    className: "block font-bold text-bunting-sea md:inline",
                                    children: "ambitious ideas"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "max-w-[555px] text-sm leading-normal text-gray-300 md:text-xl",
                            children: "From video-on-demand platforms to academic databases, GraphCMS powers some of the most innovative projects out there. Let’s talk about how we can work together on yours."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "mt-6 flex items-center text-sm font-medium text-gray-300 md:mt-auto md:text-base",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "Speak with an Expert"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_icons_arrow_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    className: "ml-2 h-5 w-5 rotate-180 transform fill-current"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    viewBox: "0 0 277 466",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "absolute top-0 right-0 z-0 h-[98px] w-[58px] md:h-[466px] md:w-[277px]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M220.985 62.05L165.74 93.077 110.495 124.1l-55.25 31.027v186.155l55.25-31.028 55.245-31.027v-62.05l-55.245 31.027v-62.05l55.245-31.027 55.245-31.027v186.154l-55.245 31.028-55.245 31.022-55.25 31.028L0 434.354l55.245 31.028 55.25-31.028 55.245-31.022 55.245-31.028 55.249-31.022V31.027L220.985 0v62.05z",
                        fill: "#11173B"
                    })
                })
            ]
        })
    }));
};


/***/ }),

/***/ 31309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W7": function() { return /* binding */ NavigationButton; },
  "Rg": function() { return /* binding */ NavigationPage; },
  "ZP": function() { return /* binding */ Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/reakit/es/Clickable/Clickable.js
var Clickable = __webpack_require__(79639);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/usePagination.ts

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DOTS = "...";
var range = function(start, end) {
    var length = end - start + 1;
    /*
  	Create an array of certain length and set the elements within it from
    start value to end value.
  */ return Array.from({
        length: length
    }, function(_, idx) {
        return idx + start;
    });
};
var usePagination = function(param) {
    var totalCount = param.totalCount, pageSize = param.pageSize, _siblingCount = param.siblingCount, siblingCount = _siblingCount === void 0 ? 1 : _siblingCount, currentPage = param.currentPage;
    var paginationRange = (0,react.useMemo)(function() {
        var totalPageCount = Math.ceil(totalCount / pageSize);
        // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*DOTS
        var totalPageNumbers = siblingCount + 5;
        /*
      If the number of pages is less than the page numbers we want to show in our
      paginationComponent, we return the range [1..totalPageCount]
    */ if (totalPageNumbers >= totalPageCount) {
            return range(1, totalPageCount);
        }
        var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
        var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
        /*
      We do not want to show dots if there is only one position left
      after/before the left/right page count as that would lead to a change if our Pagination
      component size which we do not want
    */ var shouldShowLeftDots = leftSiblingIndex > 2;
        var shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
        var firstPageIndex = 1;
        var lastPageIndex = totalPageCount;
        if (!shouldShowLeftDots && shouldShowRightDots) {
            var leftItemCount = 3 + 2 * siblingCount;
            var leftRange = range(1, leftItemCount);
            return _toConsumableArray(leftRange).concat([
                DOTS,
                totalPageCount
            ]);
        }
        if (shouldShowLeftDots && !shouldShowRightDots) {
            var rightItemCount = 3 + 2 * siblingCount;
            var rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
            return [
                firstPageIndex,
                DOTS
            ].concat(_toConsumableArray(rightRange));
        }
        if (shouldShowLeftDots && shouldShowRightDots) {
            var middleRange = range(leftSiblingIndex, rightSiblingIndex);
            return [
                firstPageIndex,
                DOTS
            ].concat(_toConsumableArray(middleRange), [
                DOTS,
                lastPageIndex
            ]);
        }
        return [];
    }, [
        totalCount,
        pageSize,
        siblingCount,
        currentPage
    ]);
    return paginationRange;
};

;// CONCATENATED MODULE: ./src/components/blog/pagination.tsx





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function NavigationButton(param) {
    var onClick = param.onClick, className = param.className, direction = param.direction;
    var Icon = direction === "prev" ? index_esm/* MdKeyboardArrowLeft */.sG8 : index_esm/* MdKeyboardArrowRight */.AeI;
    var text = direction === "prev" ? "Previous" : "Next";
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Clickable/* Clickable */.P, {
        as: "li",
        onClick: onClick,
        className: classnames_default()("inline-flex h-9 w-9 cursor-pointer items-center text-sm font-medium text-zodiac", direction === "next" && "justify-end", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                className: classnames_default()("h-5 w-5"),
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: text
            })
        ]
    }));
}
function NavigationPage(_param) {
    var onClick = _param.onClick, children = _param.children, isCurrentPage = _param.isCurrentPage, className = _param.className, props = _objectWithoutProperties(_param, [
        "onClick",
        "children",
        "isCurrentPage",
        "className"
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "md:-mt-px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clickable/* Clickable */.P, _objectSpread({
            as: "span",
            className: classnames_default()("inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-transparent px-4 text-sm font-medium transition-all", {
                'text-zodiac hover:bg-zodiac hover:text-white': !isCurrentPage,
                'bg-zodiac text-white ': isCurrentPage
            }, className),
            onClick: onClick
        }, props, {
            children: children
        }))
    }));
}
function Pagination(param) {
    var onPageChange = param.onPageChange, totalCount = param.totalCount, _siblingCount = param.siblingCount, siblingCount = _siblingCount === void 0 ? 1 : _siblingCount, currentPage = param.currentPage, pageSize = param.pageSize;
    var paginationRange = usePagination({
        currentPage: currentPage,
        totalCount: totalCount,
        siblingCount: siblingCount,
        pageSize: pageSize
    });
    if (currentPage === 0 || paginationRange.length === 1) {
        return null;
    }
    var onNext = function() {
        onPageChange(currentPage + 1);
    };
    var onPrevious = function() {
        onPageChange(currentPage - 1);
    };
    var lastPage = paginationRange[paginationRange.length - 1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "flex items-center space-x-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationButton, {
                    direction: "prev",
                    onClick: onPrevious,
                    className: classnames_default()(currentPage === 1 && "md:hidden")
                }),
                paginationRange.map(function(pageNumber, index) {
                    if (pageNumber === DOTS) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "hidden md:-mt-px md:flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-flex items-center px-4 text-sm font-medium text-zodiac",
                                children: "…"
                            })
                        }, index));
                    }
                    var isCurrentPage = pageNumber === currentPage;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationPage, {
                        onClick: function() {
                            return onPageChange(Number(pageNumber));
                        },
                        "aria-current": isCurrentPage ? "page" : undefined,
                        isCurrentPage: isCurrentPage,
                        className: "hidden md:flex",
                        children: pageNumber
                    }, index));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationButton, {
                    direction: "next",
                    onClick: onNext,
                    className: classnames_default()(currentPage === lastPage && "md:hidden")
                })
            ]
        })
    }));
};


/***/ }),

/***/ 64871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ResourceCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84193);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68663);





function ResourceCard(param) {
    var href = param.href, color = param.color, title = param.title, description = param.description, image = param.image, cta = param.cta;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        href: href,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid h-full w-full rounded-lg py-6 px-5 text-whisper transition-colors", color),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-xl font-semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-2 text-xs font-medium",
                        children: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        withArrow: true,
                        appearance: "minimal",
                        colour: "whisper",
                        size: "small",
                        className: "mt-3 text-xs font-semibold leading-3",
                        children: cta
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    src: image,
                    layout: "responsive",
                    width: 226,
                    height: 157,
                    alt: title,
                    objectFit: "contain"
                })
            })
        ]
    }, href));
};


/***/ }),

/***/ 21416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SlackBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _svg_icons_arrow_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9803);
/* harmony import */ var _svg_icons_slack_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31358);



function SlackBanner() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative overflow-hidden rounded-lg bg-white shadow-image transition-all duration-300 ease-in-out hover:shadow-card-hover",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            href: "https://slack.graphcms.com",
            target: "_blank",
            rel: "noopener noreferrer",
            className: "block h-full w-full px-4 pb-9 pt-12 md:px-9 md:pt-16",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                    className: "relative z-10 mb-6 text-xl font-bold leading-tight text-haiti md:pr-6 md:text-[38px]",
                    children: [
                        "Join our engaged",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            className: "block font-bold text-cornflower md:inline",
                            children: "Slack community"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-sm leading-normal text-light-haiti md:text-xl",
                    children: "Connect with an engaged community to get your questions answered and learn about new opportunities in the GraphQL space."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "mt-6 flex items-center text-sm font-medium text-cornflower md:mt-10 md:text-base",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "Join Slack Channel"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_icons_arrow_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            className: "ml-2 h-5 w-5 rotate-180 transform fill-current"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_icons_slack_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "absolute top-0 right-0 z-0 -mt-2 -mr-2 h-20 w-20 text-catskill-white lg:h-32 lg:w-32"
                })
            ]
        })
    }));
};


/***/ }),

/***/ 26182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CaseStudyCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84193);
/* harmony import */ var _components_blog_badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7272);
/* harmony import */ var _components_blog_card_cta_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89130);
/* harmony import */ var _utils_resolvers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16019);






function CaseStudyCard(param) {
    var slug = param.slug, coverImage = param.coverImage, subTitle = param.subTitle, title = param.title, useCases = param.useCases;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "flex w-full flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "blog-image flex-shrink-0",
                children: (coverImage === null || coverImage === void 0 ? void 0 : coverImage.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    href: "/case-studies/".concat(slug),
                    className: "blog-card-image",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        src: coverImage.url,
                        alt: coverImage.alt || "",
                        width: 384,
                        height: 216,
                        quality: 100,
                        layout: "responsive",
                        objectFit: "cover",
                        className: "rounded bg-catskill-white"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "blog-card-text flex flex-1 flex-col py-4 md:px-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "-ml-1",
                                children: useCases.length > 0 && useCases.map(function(useCase, index) {
                                    // If there are more than two categories, we show just the first ones
                                    if (index > 1) return null;
                                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_blog_badge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        slug: "/case-studies/use-case/".concat(useCase.slug),
                                        title: useCase.title,
                                        variant: "primary",
                                        className: "mr-1"
                                    }, useCase.slug));
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                href: "/case-studies/".concat(slug),
                                className: "transition-colors hover:text-cornflower",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "blog-card-title mt-4 mb-5 text-[22px] font-bold leading-tight",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "leading-normal text-light-haiti",
                                        children: (0,_utils_resolvers__WEBPACK_IMPORTED_MODULE_5__/* .truncateText */ .a)({
                                            text: subTitle
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-6 flex justify-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_blog_card_cta_link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            href: "/case-studies/".concat(slug),
                            text: "Learn more"
                        })
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 40104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var reakit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76152);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Container(_param) {
    var children = _param.children, className = _param.className, props = _objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reakit__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, _objectSpread({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mx-auto max-w-6xl px-6", className)
    }, props, {
        children: children
    })));
};


/***/ }),

/***/ 54391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ CaseStudies; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/url-join/lib/url-join.js
var url_join = __webpack_require__(34078);
var url_join_default = /*#__PURE__*/__webpack_require__.n(url_join);
// EXTERNAL MODULE: ./src/components/Layout/Vanilla.tsx + 22 modules
var Vanilla = __webpack_require__(1635);
// EXTERNAL MODULE: ./src/components/container.tsx
var container = __webpack_require__(40104);
// EXTERNAL MODULE: ./src/components/Heading.tsx
var Heading = __webpack_require__(34465);
// EXTERNAL MODULE: ./src/components/blog/badge.tsx
var badge = __webpack_require__(7272);
// EXTERNAL MODULE: ./src/components/blog/cards-container.tsx
var cards_container = __webpack_require__(11417);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/components/link.tsx
var components_link = __webpack_require__(84193);
// EXTERNAL MODULE: ./src/utils/resolvers.ts
var resolvers = __webpack_require__(16019);
// EXTERNAL MODULE: ./src/components/blog/card-cta-link.tsx
var card_cta_link = __webpack_require__(89130);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
;// CONCATENATED MODULE: ./src/components/case-studies/featured-case-study.tsx







function FeaturedPost(param) {
    var coverImage = param.coverImage, slug = param.slug, subTitle = param.subTitle, title = param.title;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col items-center justify-between md:flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "blog-image w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* default */.Z, {
                    href: "/case-studies/".concat(slug),
                    className: "blog-card-image",
                    children: (coverImage === null || coverImage === void 0 ? void 0 : coverImage.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        width: 740,
                        height: 422,
                        src: coverImage.url,
                        alt: coverImage.alt || "",
                        className: "rounded",
                        objectFit: "cover",
                        layout: "responsive",
                        priority: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "blog-card-text mt-4 w-full sm:flex-col md:ml-10 md:mt-0 md:max-w-sm lg:ml-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                            as: "text",
                            title: "Featured",
                            variant: "primary"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* default */.Z, {
                        href: "/case-studies/".concat(slug),
                        className: "blog-card-title space-y-4 transition-colors hover:text-cornflower",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-[22px] font-bold leading-tight md:text-3xl",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "leading-normal text-light-haiti",
                                children: (0,resolvers/* truncateText */.a)({
                                    text: subTitle || ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                withArrow: true,
                                colour: "purple",
                                className: "hidden md:flex",
                                children: "Learn more"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 flex items-center justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_cta_link/* default */.Z, {
                            href: "/case-studies/".concat(slug),
                            className: "flex-shrink-0 lg:hidden",
                            text: "Learn more"
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/blog/pagination.tsx + 1 modules
var pagination = __webpack_require__(31309);
// EXTERNAL MODULE: ./src/components/case-studies/case-study-card.tsx
var case_study_card = __webpack_require__(26182);
// EXTERNAL MODULE: ./src/components/blog/slack-card.tsx
var slack_card = __webpack_require__(21416);
// EXTERNAL MODULE: ./src/components/blog/enterprise-card.tsx
var enterprise_card = __webpack_require__(16206);
// EXTERNAL MODULE: ./src/styles/pages/blog-index.module.css
var blog_index_module = __webpack_require__(77049);
var blog_index_module_default = /*#__PURE__*/__webpack_require__.n(blog_index_module);
// EXTERNAL MODULE: ./src/utils/data/resource-cards.ts + 3 modules
var resource_cards = __webpack_require__(15161);
// EXTERNAL MODULE: ./src/components/blog/resource-card.tsx
var resource_card = __webpack_require__(64871);
// EXTERNAL MODULE: ./next-seo.config.ts
var next_seo_config = __webpack_require__(98128);
;// CONCATENATED MODULE: ./src/pages/case-studies/index.tsx



















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// The limit is 10 because we remove the featured post from the list
var limit = 10;
var __N_SSP = true;
function CaseStudies(param) {
    var totalCount = param.totalCount, page = param.page, successStoryUseCases = param.successStoryUseCases, isFirstPage = param.isFirstPage, currentPage = param.currentPage, hasPreviousPage = param.hasPreviousPage, hasNextPage = param.hasNextPage, preview = param.preview, featuredCaseStudy = param.featuredCaseStudy, successStories = param.successStories;
    var router = (0,next_router.useRouter)();
    var pageUrl = url_join_default()(next_seo_config/* defaultSeoUrl */.h, router.asPath);
    var pageTitle = !isFirstPage ? "Page ".concat(currentPage, " | ").concat(page === null || page === void 0 ? void 0 : page.title) : page === null || page === void 0 ? void 0 : page.title;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    hasPreviousPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "prev",
                        href: "/case-studies?page=".concat(currentPage - 1)
                    }),
                    hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "next",
                        href: "/case-studies?page=".concat(currentPage + 1)
                    }),
                    !isFirstPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: pageUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Vanilla/* default */.Z, {
                seo: {
                    meta: _objectSpread({}, page === null || page === void 0 ? void 0 : page.seo, {
                        title: pageTitle
                    }),
                    title: (page === null || page === void 0 ? void 0 : page.title) || "",
                    subTitle: page === null || page === void 0 ? void 0 : page.subTitle,
                    coverImage: (page === null || page === void 0 ? void 0 : page.coverImage) || {}
                },
                preview: preview,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            children: "Case Studies"
                        }),
                        successStoryUseCases.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6 space-y-3 lg:space-y-2",
                            children: successStoryUseCases.map(function(useCase) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(badge/* default */.Z, {
                                    slug: "/case-studies/use-case/".concat(useCase.slug),
                                    title: useCase.title,
                                    variant: "default",
                                    className: "mr-3 lg:mr-2"
                                }, useCase.slug);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedPost, _objectSpread({}, featuredCaseStudy))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_container/* default */.Z, {
                            className: "mt-10 lg:mt-20",
                            children: successStories === null || successStories === void 0 ? void 0 : successStories.map(function(successStory) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(case_study_card/* default */.Z, _objectSpread({}, successStory), successStory.slug);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.ZP, {
                                currentPage: currentPage,
                                totalCount: totalCount,
                                pageSize: limit,
                                onPageChange: function(pageNumber) {
                                    router.push("/case-studies?page=".concat(pageNumber));
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-20 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4",
                            children: resource_cards/* resourceCards.map */.G.map(function(item) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(resource_card/* default */.Z, _objectSpread({}, item), item.href);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("mt-20 mb-12 lg:mb-36", (blog_index_module_default()).cardsFooter),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(slack_card/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(enterprise_card/* default */.Z, {})
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 15161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ resourceCards; }
});

;// CONCATENATED MODULE: ./public/images/blog/academy-card.png
/* harmony default export */ var academy_card = ({"src":"/_next/static/media/academy-card.f9268ff5.png","height":328,"width":468,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAP1BMVEX6+/7W2u3e4vD////S2fRwgcK9u+5MaXHHzu98jcuNm86PltjEzO7HzfDZ3e7K0eZ4icnCyurz9PvJ0O3g5fpsuKVcAAAAEnRSTlP+v/s2/mwTAOv+mxrZscFQPHfzz4hhAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVQImQXBBwIAEAwEsFN02Fr/f6sE9uCeRWDFPVqtsAeUiIFzU1LVCdlEqzN/JFoBhQl7dPgAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/blog/community-card.png
/* harmony default export */ var community_card = ({"src":"/_next/static/media/community-card.613fc922.png","height":336,"width":450,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAUVBMVEXxk8L+7fLwnsTydqr+9vf+xeD55e3nbar1osn9uNrxeqziX6H6q87/w+H9t9n72Ob////73unoeK7uiLbvjbnod63tkbzhZqT3t9T/+PnylLx75DimAAAAGHRSTlMB/VwgVPgc+/qRL7r432j6Lv6b6N7DvlXueLh5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVQImRXGRxaAIAxAwU9NggUFC3r/g/qc1RBKCfnqjUlE/PGef9TV3XOrzsk9G6QxlhgzmNkKfDcfAeCK36IPAAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./public/images/blog/documentation-card.png
var documentation_card = __webpack_require__(57508);
;// CONCATENATED MODULE: ./public/images/blog/write-card.png
/* harmony default export */ var write_card = ({"src":"/_next/static/media/write-card.856a5b5b.png","height":327,"width":490,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAASFBMVEVMaXH++Oj+/u/8+N///+388M3iSgD+/ev66bv//eX+/Oj++N703bH88tb//+r//vb52rL54L/+/e3999/+/ev///r++eD87M3P+ainAAAAFnRSTlMA8O9PjroN/vZF3t+dZBWk44Wx3qP7acQdEwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC9JREFUCJkFwYUBwCAQALFDH2lx2X9TEkzISVvgC0dkAf89ItZ7SoxujtYBnFK7Ph3fAWHemRZfAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/utils/data/resource-cards.ts




var resourceCards = [
    {
        href: "/academy",
        cta: "Learn more",
        title: "Academy",
        description: "Learn the basics about Headless CMS, GraphQL, DXP and more.",
        color: "bg-indigo-rainbow hover:bg-zodiac",
        image: academy_card
    },
    {
        href: "/community",
        cta: "Check them out",
        title: "Community",
        description: "See what the GraphCMS community is building and share your own.",
        color: "bg-pink-600 hover:bg-pink-700",
        image: community_card
    },
    {
        href: "/docs",
        cta: "Explore Docs",
        title: "Documentation",
        description: "Get started with your project with our API and SDK documentation.",
        color: "bg-green-600 hover:bg-green-700",
        image: documentation_card/* default */.Z
    },
    {
        href: "/write-for-graphcms",
        cta: "Create content",
        title: "Write for GraphCMS",
        description: "Share your technical expertise and help other developers learn.",
        color: "bg-spanish-yellow hover:bg-yellow-600",
        image: write_card
    }, 
];


/***/ }),

/***/ 16019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ truncateText; }
/* harmony export */ });
function truncateText(param) {
    var text = param.text, _length = param.length, length = _length === void 0 ? 24 : _length;
    if (!text) return null;
    var splitText = text.split(" ");
    if (splitText.length < length) return text;
    return "".concat(splitText.splice(0, length).join(" "), "...");
}


/***/ }),

/***/ 77049:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsFooter":"pages_cardsFooter__h4_Tf"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3781,4814,7906,5343,1635,9774,2888,179], function() { return __webpack_exec__(94432); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);